/**
 * @description every translation json with a code
 * along with it.
 *
 * @example translations = {
 *     en: { require('./en.json') },
 *     es: { require('./en.json') }
 * }
 */
const translations = {

};

export default translations;
